export default {
    ABOUT: "À propos de",
    ADVANCED_TOOLS: "Outils avancés pour les commerçants",
    APPROVE: "Approuver",
    APY: "Apy",
    AUDITS: "Audits",
    BAL: "BAL:",
    BITCOIN_C: "Bitcoin",
    BITCOIN_S: "Bitcoin",
    BRAND_BLOG: "Blog de marque",
    BURNED_TOKEN: "Jeton brûlé",
    BUY_FARM_SPEND: "Achetez-le, cultivez-le, dépensez-le et jouez-le!",
    BUY_ONE80_TOKENS: "Acheter des jetons Metadiac",
    CANCEL: "Annuler",
    CIRCULATE_SUPPLY: "Alimentation en circulation",
    CLOSE: "proche",
    COMMUNITY: "Communauté",
    COMMUNITY_JOIN: "Metadiac transforme le monde Defi, notre communauté et nos développeurs créent un monde financier sans pensionnaires, une plate-forme de trading Defi pour l'instant et à l'avenir. Rejoignez-nous!",
    CONFIRM: "Confirmer",
    CONFIRM_SWAP: "Confirmer l'échange",
    CONNECT_WALLET: "Connectez-vous à un portefeuille",
    CONNECT_WALLET_TRADE_TOKEN: "Connectez votre portefeuille, échangez n'importe quel jeton sur ETH en quelques secondes.",
    CONTRIBUTORS: "Contributeurs",
    CRYPTO_GROW: "Surveillez votre crypto grandir!",
    CUSTOMER_SUPPORT: "Service client",
    DEPOSIT_FEE: "Frais de dépôt:",
    DETAILS: "Détails",
    DEVELOPERS: "Développeurs",
    DISCONNECT_WALLET: "Débrancher le portefeuille",
    DOCUMENTATION: "Documentation",
    EARNED: "Mérité",
    EARN_PASSIVE_INCOME: "Gagnez un revenu passif 24/7 avec Metadiac",
    EARN_WHILE_SLEEP: "Gagnez pendant que vous dormez!",
    ETHEREUM: "Binance",
    EXCHANGE: "Échanger",
    FARMS: "Fermes",
    FARMS_POOLS: "Fermes et piscines",
    FINISHED: "Achevé",
    GITHUB: "Github",
    GUIDES: "Guides",
    HARVEST: "Récolter",
    HEART_ECOSYSTEM: "Metadiac Token est au cœur de notre écosystème.",
    HELP: "Aider",
    IDEAS_LAB: "Laboratoire d'idées",
    JOIN_ONE80: "Rejoignez la révolution Metadiac Defi.",
    LAUNCH_APP: "Lancer l'application",
    LIQUIDITY: "Liquidité",
    LIQUIDITY_PROVIDER_FEE: "Frais de fournisseur de liquidité",
    LITE_PAPER: "Du papier",
    LIVE: "Vivre",
    LOADING: "Chargement...",
    LOAD_MORE: "Charger plus",
    MARKET_CAP: "Capitalisation boursière",
    MAX: "Max",
    MINIMUM_RECEIVED: "Minimum reçu",
    MULTICHAIN_INSTANT_ACCESS: "Multichain arrive bientôt, vous donnant un accès instantané à un monde de crypto.",
    NO_FARMS: "Pas de fermes",
    NO_POOLS: "Pas de piscines",
    ONE80: "Metadiac",
    ONE80_BENEFITS: "Metadiac avantages pour tous, Hodl, échange et échange 24/7.",
    ONE80_EARNED: "Metadiac gagné",
    ONE80_MAKES_EASY: "Metadiac facilite le fonctionnement de votre crypto pour vous.",
    ONE80_WORLD: "Metadiac fait tourner notre monde.",
    OUTPUT_ESTIMATED: "La sortie est estimée. Si le prix change de plus de 0,8%, votre transaction reviendra.",
    OUTPUT_RECEIVE_ATLEAST: "La sortie est estimée. vous recevrez au moins",
    PARTHER_BURNED: "LP Parther / Busd Burned",
    POOLS: "Piscines",
    PRICE: "Prix",
    PRICE_IMPACT: "Impact sur les prix",
    READABLE_CONTENT: "C'est un fait établi depuis longtemps qu'un lecteur sera distrait par le contenu lisible.",
    SEARCH_FARMS: "Recherchez les fermes",
    SEARCH_POOLS: "Piscines de recherche",
    SORT_BY: "Trier par",
    STAKE: "Pieu:",
    STAKED_ONLY: "Joué uniquement",
    STAKE_EARN_ONE80: "Jetons de pieu pour gagner Metadiac",
    STAKE_ONE80: "Les jetons LP de pieu pour gagner Metadiac",
    STAKE_TOKENS: "Jetons de pieu",
    START_EARNING: "Commencer a gagner",
    SUCCESS_COMPLETE: "Complété avec succès",
    SUSTAIN: "Durabilité",
    TOKEN_PRICE: "Prix ​​de jeton",
    TOTAL_LIQUIDITY: "Liquidité totale:",
    TOTAL_STAKE: "Jalon total:",
    TOTAL_STAKED_S: "Total de jalon",
    TOTAL_SUPPLY: "Approvisionnement total",
    TRADERS_CHOOSE_ONE80: "Les traders choisissent Metadiac pour échanger et acheminer automatiquement les métiers vers les meilleurs DEX, vous donnant les meilleurs résultats.",
    TRADE_EARN_JOIN: "Commerce, gagner et rejoindre notre communauté, bénéficier de 80 récompenses.",
    TRADE_NOW: "Échangeons maintenant",
    TRADE_REGISTRATION_HASSLE: "Échanger quoi que ce soit. Pas d'inscription, pas de tracas",
    TRANSACTION_REVERT: "ou la transaction reviendra.",
    TROUBLE_SHOOT: "Difficulté",
    TRUSTED_WORLD: "TRAIDE WORDWIDE",
    UNLOCK_WALLET: "Déverrouiller le portefeuille",
    UNSTAKE_TOKENS: "Dénombrement des jetons",
    VIEW_ETHERSCAN: "Voir sur BscScan",
    YOU_RECEIVE: "Tu recevras",
    //Exchange and Liquidity
    ADD: "Ajouter",
    ADD_LIQUIDITY: "Ajouter des liquidités",
    AMOUNT: "Montant",
    BALANCE: "Solde:",
    CLICK_SUPPLY_REVIEW: "Une fois que vous êtes satisfait du taux, cliquez sur l'offre pour examiner.",
    CONNECT_WALLET_LIQUIDITY: "Connectez-vous à un portefeuille pour afficher votre liquidité.",
    CREATE_PAIR: "Créer une paire",
    CREATE_POOL: "Créer une piscine.",
    DONT_HAVE_LIQUIDITY: "Vous n'avez pas encore de liquidité dans cette piscine.",
    DONT_SEE_POOL_JOINED: "Vous ne voyez pas une piscine que vous avez rejointe?",
    ENABLE: "Activer",
    ENTER_AMOUNT: "Entrer le montant",
    ENTER_AMOUNT_S: "Entrer le montant",
    FIRST_LIQUIDITY_PROVIDER: "Vous êtes le premier fournisseur de liquidité.",
    FOR: "pour",
    FROM: "De",
    IMPORT_IT: "L'importez-le.",
    IMPORT_POOL: "Pool d'importation",
    INSUFFICIENT: "Insuffisant",
    INSUFFICIENT_BALANCE: "Solde insuffisant",
    INSUFFICIENT_LIQUIDITY: "Une liquidité insuffisante pour ce commerce.",
    LIQUIDITY_PROV_FEE: "Frais du fournisseur de liquidité:",
    LIQUIDITY_REWARDS: "Récompenses du fournisseur de liquidité",
    LP_TOKENS_IN_WALLET: "Les jetons LP dans votre portefeuille",
    MINUTES: "Minutes",
    NO_LIQUTITY_LIST: "Aucune liste de liqutity",
    NO_POOL_FOUND: "Aucune piscine trouvée.",
    PER: "par",
    POOL: "Piscine",
    POOL_FOUND: "Piscine trouvée!",
    POOL_SHARE: "Votre partage de piscine:",
    POOL_TOKENS: "Vos jetons de piscine:",
    PRICE_IMPACTS: "Impact du prix:",
    PRICE_IMPACT_HIGH: "Impact du prix à haut",
    RATES: "Les taux",
    RATIO_PRICE_POOL: "Le rapport des jetons que vous ajoutez fixera le prix de ce pool.",
    RECENT_TRANSACTIONS: "transactions récentes",
    REMOVE: "Retirer",
    REMOVE_LIQUIDITY: "Retirer la liquidité",
    REMOVING_POOL_TOKENS: "La suppression des jetons de piscine convertit votre position en jetons sous-jacents au taux actuel, proportionnel à votre part de la piscine. Les frais accumulés sont inclus dans les montants que vous recevez.",
    ROUTE: "Itinéraire:",
    SELECT_A_TOKEN: "Sélectionnez un jeton",
    SETTINGS: "Réglages",
    SHARE_OF_POOL: "Part de piscine:",
    SLIPPAGE_TOL: "Tolérance de glissement",
    SLIPPAGE_TOLERANCE: "Tolérance à glissement:",
    SUPPLY: "Fournir",
    SWAP: "Échanger",
    TO: "À",
    TOKEN_FARM_UNSTAKE: "Ou, si vous avez jalonné vos jetons Metadiac-LP dans une ferme, découragez-les pour les voir ici.",
    TRANSACTION_DEADLINE: "Date limite de transaction",
    TRANSACTION_NOT_FOUND: "La traversée n'est pas trouvée",
    TRANSACTION_REVERT_PERCENTAGE: "Votre trasaction reviendra si le prix change défavorablement de plus que ce pourcentage",
    WITHDRAW_LIQUIDITY: "Les fournisseurs de liquidités obtiennent des frais de 0.25%% sur tous les métiers proportionnels à leur part du pool. Des frais sont ajoutés à la piscine, accumulent en temps réel et peuvent être réclamés en retirant votre liquidité.",
    YOUR_LIQUIDITY: "Votre liquidité",
    bALANCE: "solde",
    MAXIMUM_SOLD: "Maximum vendu",
    MINIMUM_RECEIVED_C: "Minimum reçu",
    TOKEN_NAME: "Nom de jeton",
    FOUND_MY_ADDRESS: "Trouvé par adresse",
    IMPORT_TOKEN: "Jeton d'importation",
    SEARCH_NAME: "Recherche par noms ou adresse",

    AND: "et",
    CONFIRM_SUPPLY: "Confirmer l'offre",
    CONFIRM_TRANSACTION_WALLET: "Confirmez cette transaction dans votre portefeuille",
    CONNECT_WALLETTT: "Portefeuille de connexion",
    DEPOSITED: "Déposé:",
    DISMISS: "Rejeter",
    ERROR: "Erreur",
    INPUT_ESTIMATED_SELL_MOST: "L'entrée est estimée. Vous vendrez au plus",
    LEARN_ABOUT_WALLETS: "En savoir plus sur les portefeuilles",
    NEW_TO_ETHEREUM: "Nouveau sur Binance?",
    OUTPUT_ESTIMATED_PRICE_CHANGES: "La sortie est estimée. Si le prix change de plus de",
    PRICEE: "Prix:",
    SUPPLYING: "Approvisionnement",
    SWAPPING: "Échange",
    TRANSACTION_REJECTED: "Transaction rejetée",
    TRANSACTION_SUBMITTED: "Transaction soumise",
    VIEW_ON_BSCSCAN: "Voir sur bsccan",
    WAITING_CONFIRMATION: "En attente de confirmation",
    YOUR_TRANSACTION_REVERT: "Votre transaction reviendra.",
    YOU_WILL_RECEIVE: "Vous allez recevoir :",
    PARTNERSHIPS: "Partenariats",
}